import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { ModalDirective } from 'angular-bootstrap-md';
import { Component,OnInit, ViewChild } from '@angular/core';
import {TitleService} from "./title.service";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  @ViewChild('basicModal') basicModal: ModalDirective;
  ngAfterViewInit() {
   // this.basicModal.show();
  }
  constructor(private titleService: TitleService){}

  ngOnInit(): void {
    this.titleService.init();
  }
  
 
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/app.component.ts